import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface ModalOptions {
  header?: string;
  body?: string;
  confirmText?: string;
  cancelText?: string;
  confirmColor?: 'success' | 'danger';
  cancelColor?: 'success' | 'danger';
}

export type ModalResult = 'confirm' | 'cancel';

@Injectable({ providedIn: 'root' })
export class ModalService {
  private modalState$ = new BehaviorSubject<ModalOptions | null>(null);
  private resolver: ((result: ModalResult) => void) | null = null;

  get modalState() {
    return this.modalState$.asObservable();
  }

  open(options: ModalOptions): Promise<ModalResult> {
    this.modalState$.next(options);
    return new Promise<ModalResult>((resolve) => {
      this.resolver = resolve;
    });
  }

  confirm() {
    this.close('confirm');
  }

  cancel() {
    this.close('cancel');
  }

  private close(result: ModalResult) {
    this.modalState$.next(null);
    if (this.resolver) {
      this.resolver(result);
      this.resolver = null;
    }
  }
} 